import React, { useEffect, useState, useRef } from "react";
import API_BASE_URL from "../Config.js";
import "../styles/Table.css"; // Table 스타일

import * as XLSX from 'xlsx'; // 💡 라이브러리 임포트 필수


function UserList() {
    
    // 컴포넌트 내부 상단에 추가
    const [editingId, setEditingId] = useState(null); 
    const [users, setUsers] = useState([]);


     // 1️⃣ [가장 먼저 작성] 무조건 상태(State) 선언이 최상단에 와야 합니다!
    const [currentPage, setCurrentPage] = useState(1); 
    //const [editingId, setEditingId] = useState(null); // (있다면 같이 상단 배치)

    // 2️⃣ [그 다음 작성] 상수 설정
    const ITEMS_PER_PAGE = 10; 
    const PAGE_GROUP_SIZE = 10; 

    // 3️⃣ [그 다음 작성] 위에서 선언한 변수들을 바탕으로 계산하는 식들
    const totalPages = Math.ceil(users.length / ITEMS_PER_PAGE);

    const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
    const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
    const currentUsers = users.slice(indexOfFirstItem, indexOfLastItem);

    // 4️⃣ [함수 작성] 핸들러 함수들
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        setEditingId(null); 
    };


    const [newUser, setNewUser] = useState({
        login_id: "",
        password: "",
        name: ""
    });
    const [idError, setIdError] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const token = sessionStorage.getItem("token");

    // 액셀저장 => 기존 컴포넌트 함수 내부...
    const [excelRows, setExcelRows] = useState([]); // 파싱된 데이터 저장
    const [uploadProgress, setUploadProgress] = useState({ current: 0, total: 0 });
    const [isExcelUploading, setIsExcelUploading] = useState(false);
    const excelInputRef = useRef(null);
    const [modalType, setModalType] = useState(null); // null, 'write', 'detail', 'reply'

    // 💡 엑셀 파일을 읽어서 2차원 배열로 상태에 저장하는 함수
    const handleExcelFileChange = (e) => {
      const file = e.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (evt) => {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });
        const wsname = wb.SheetNames[0]; // 첫 번째 시트 확보
        const ws = wb.Sheets[wsname];

        // 2차원 배열 구조로 데이터 변환 [[A1, B1], [A2, B2]]
        const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

        setExcelRows(data);
        setUploadProgress({ current: 0, total: data.length > 1 ? data.length - 1 : 0 });
      };
      reader.readAsBinaryString(file);
    };

    // 💡 [저장 시작] 버튼 클릭 시 한 줄씩 Go 백엔드로 전송하는 함수
    const handleExcelSaveSubmit = async () => {
      if (excelRows.length <= 1) {
        alert("저장할 데이터가 없거나 첫 줄 외에 내용이 비어있습니다.");
        return;
      }

      setIsExcelUploading(true);
      let successCount = 0;

      // ⭐ 첫 번째 줄(index 0)은 제목 줄이라서 패스 (slice(1) 사용)
      const dataRows = excelRows.slice(1);
      const totalRows = dataRows.length;
      const currentuserId = sessionStorage.getItem("userId")

      for (let i = 0; i < totalRows; i++) {
        const row = dataRows[i];
        if (!row || row.length === 0) continue; // 빈 행 예외처리

        try {
          const response = await fetch(`${API_BASE_URL}/users/insert`, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `Bearer ${token}`
                                },
            body: JSON.stringify({
              login_id : String(row[0] || ""), // ID
              name: String(row[1] || ""), // 이름
              password: String(row[2] || ""), // 비밀번호
              userId : currentuserId
            }),
          });

          if (response.ok) successCount++;
        } catch (error) {
          console.error(`${i + 1}번째 행 전송 중 통신 에러:`, error);
        }

        // 💡 루프가 돌 때마다 실시간 진행률 업데이트
        setUploadProgress(prev => ({ ...prev, current: i + 1 }));
      }

      setIsExcelUploading(false);
      alert(`엑셀 등록 완료! 총 ${totalRows}개 중 ${successCount}개 성공`);

      // 상태 및 인풋 초기화
      setExcelRows([]);
      setModalType(null);
      if (excelInputRef.current) excelInputRef.current.value = "";

      // 필요 시 기존 목록 리로드 함수 호출 (예: fetchBoards())
      if (typeof fetchUsers === 'function') fetchUsers(); 
    };


    const handleInputChange = (login_id, field, value) => {
        setUsers(prev => prev.map(u =>
            u.login_id === login_id ? { ...u, [field]: value } : u
        ));
    };

    // 🛠️ 머스크 원칙에 입각해 부품(타이머)을 제거하고 논리만 남긴 함수
    const handleBlurOrEnter = (e, currentLoginId) => {
        // 엔터키 종료
        if (e.key === 'Enter') {
            setEditingId(null);
            return;
        }

        // 포커스를 잃었을 때(blur)
        if (e.type === 'blur') {
            // 관련 타겟(마우스가 새로 이동한 곳)이 여전히 현재 수정 중인 input 내부라면 닫지 않는다.
            if (e.relatedTarget && e.relatedTarget.className === "editable-input") {
                return; 
            }
            setEditingId(null);
        }
    };
    
    // 두 글자만 남기고 나머지는 *로 변환하는 함수
    const maskText = (text) => {
        if (!text) return "";
        if (text.length <= 2) return text; // 2글자 이하이면 그대로 표시
        return text.substring(0, 2) + "*".repeat(text.length - 2);
    };




    // --- 검색(조회) 관련 상태 ---
    const [searchTerm, setSearchTerm] = useState(""); // 입력 검색어 저장

    const fetchUsers = () => {

            const url = `${API_BASE_URL}/users`;
            
            fetch(url, { 
                method: "POST",

                headers: { 
                    "Content-Type": "application/json",

                    Authorization: `Bearer ${token}` 
                }           
            
                , body: JSON.stringify({ searchTerm }) // 검색어를 JSON 형태로 전송
            })
            .then(res => {
                if (!res.ok) throw new Error(`서버 응답 오류: ${res.status}`);
                return res.json();
            })
            .then(data => {
                // console.log("응답 데이터:", data);  // 여기서 확인
                if (Array.isArray(data)) {
                    setUsers(data);                  // 상태 업데이트
                    //console.log("사용자 목록:", data);  // 사용자 목록 확인
                } else {
                    setUsers([]);                    // 배열이 아닐 경우 안전하게 빈 배열로
                }
            })
            .catch(err => {
                console.error("에러 발생:", err);  // 에러도 함께 확인
                setUsers([]);                     // 에러 시에도 빈 배열로 초기화
            });
        };

    useEffect(() => {
        fetchUsers();
    }, []);

    const handleUpdate = (login_id, field, value) => {
        const updated = users.map(u =>
            u.login_id === login_id ? { ...u, [field]: value } : u
        );
        setUsers(updated);

        const currentuserId = sessionStorage.getItem("userId")
        const payload = updated.find(u => u.login_id === login_id);
        payload.userId = currentuserId; // 수정하는 사람의 ID도 함께 전송

        fetch(`${API_BASE_URL}/users/update`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(payload)
        })
        .then(res => {
            if (!res.ok) throw new Error("수정 실패");
            return res.json();
        })
        .then(data => console.log("수정 성공:", data))
        .catch(err => console.error("수정 에러:", err));


    };


    return (
        <div>
            {/* [추가] 프로그램 제목 영역 */}
            <h2 style={{ marginBottom: "15px", color: "#333", borderBottom: "2px solid #333", paddingBottom: "10px" }}>
                🧑🏻‍🎓 사용자(교수/학생) 계정 관리 
            </h2>

            {/* 상단 검색 바 및 컨트롤 버튼 */}
            <div className="search-bar" style={{ marginBottom: "15px", display: "flex", gap: "10px", alignItems: "center" }}>
                <input
                    type="text"
                    placeholder="ID 또는 이름 검색..."
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        //setCurrentPage(1); // 검색어 변경 시 1페이지로 이동
                    }}
                    style={{ padding: "8px", width: "250px", borderRadius: "4px", border: "1px solid #ccc" }}
                />
                {/* 검색 버튼 */}
                <button 
                    onClick={() => {fetchUsers(); setCurrentPage(1)}} // 현재 구조에서는 필터가 실시간 적용되므로 페이지 리셋 역할
                    style={{ 
                        padding: "8px 16px", 
                        backgroundColor: "#007bff", 
                        color: "#fff", 
                        border: "none", 
                        borderRadius: "4px", 
                        cursor: "pointer" 
                    }}
                >
                    검색
                </button>

                <button 
                  type="button"
                  onClick={() => setModalType('excelUpload')} 
                  style={{ padding: '6px 12px', fontSize: '14px', borderRadius: '4px', border: 'none', color: '#fff', background: '#17a2b8' }}
                >
                  📊 엑셀 데이터 등록
                </button>
                {/* 추가 버튼 */}
                <button 
                    onClick={() => {setNewUser({ login_id: "", password: "", name: "" });
                                    setIdError(""); setIsModalOpen(true);}} // 나중에 모달 오픈 함수나 페이지 이동 연결
                    style={{ 
                        padding: "8px 16px", 
                        backgroundColor: "#28a745", 
                        color: "#fff", 
                        border: "none", 
                        borderRadius: "4px", 
                        cursor: "pointer",
                        marginLeft: "auto" // 오른쪽 끝으로 배치하고 싶다면 유지, 왼쪽에 붙이려면 삭제
                    }}
                >
                    추가
                </button>
            </div>

            <table className="modern-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>이름</th>
                        <th>비밀번호</th>                        
                        <th>최근로그인</th>
                        <th>삭제</th>
                    </tr>
                </thead>
                <tbody>
                    {/* [변경 핵심] users.map 대신 현재 페이지 데이터인 currentUsers.map을 사용합니다. */}
                    {currentUsers.map((u, index) => (
                        <tr key={`${u.login_id}-${index}`}>                            
                            <td className="fixed-cell" readOnly>
                                {u.login_id}
                            </td>
                            <td>
                                <input
                                    className="editable-input"
                                    value={u.name}
                                    onChange={e => handleInputChange(u.login_id, "name", e.target.value)}
                                    onBlur={e => handleUpdate(u.login_id, "name", e.target.value)}
                                />
                            </td>
                            <td>
                                {/* 1. 팝업을 띄우기 위해 최외곽을 div로 감싸줍니다 */}
                                <div className="tooltip-container">
                                    
                                    <input
                                        type="text"
                                        className="editable-input"
                                        value={editingId === u.login_id ? (u.password || "") : (u.password || "")}
                                        placeholder={editingId === u.login_id ? "4글자 이상 입력" : "더블 클릭하여 수정"}
                                        readOnly={editingId !== u.login_id}
                                        onDoubleClick={() => setEditingId(u.login_id)}
                                        onKeyDown={handleBlurOrEnter}
                                        onChange={e => handleInputChange(u.login_id, "password", e.target.value)}
                                        onBlur={e => handleUpdate(u.login_id, "password", e.target.value)}
                                    />

                                    {/* 2. 편집 모드가 아닐 때만 "더블클릭시 변경" 팝업이 노출되도록 제어 */}
                                    {editingId !== u.login_id && (
                                        <span className="tooltip-text">더블클릭시 변경</span>
                                    )}
                                </div>
                            </td>
                                
                            <td>
                                <input
                                    className="uneditable-input"
                                    value={u.last_log || ''}
                                    readOnly
                                />
                            </td>
                            <td>
                                <select
                                    className="editable-select"
                                    value={u.state_fg}
                                    onChange={e =>
                                        handleUpdate(u.login_id, "state_fg", parseInt(e.target.value))
                                    }
                                >
                                    <option value={0}>정상</option>
                                    <option value={1}>삭제</option>
                                </select>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
                
            {/* --- 하단 페이징 네비게이션 버튼 바 --- */}
            {totalPages > 1 && (() => {
               // const PAGE_GROUP_SIZE = 10; 
                const currentGroup = Math.floor((currentPage - 1) / PAGE_GROUP_SIZE);
                const startPage = currentGroup * PAGE_GROUP_SIZE + 1;
                const endPage = Math.min(startPage + PAGE_GROUP_SIZE - 1, totalPages);
                const visiblePages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
            
                return (
                    <div className="pagination-container">
                        {/* 맨 처음으로 가는 버튼 (<<) - 페이지가 많을 때 유용합니다 */}
                        <button 
                            className="page-btn direction"
                            disabled={currentPage === 1}
                            onClick={() => handlePageChange(1)}
                        >
                            처음
                        </button>

                        {/* < 이전 버튼 (이전 그룹의 마지막 페이지로 이동) */}
                        <button 
                            className="page-btn direction"
                            disabled={currentPage === 1}
                            onClick={() => handlePageChange(Math.max(1, startPage - 1))}
                        >
                            이전
                        </button>

                        {/* ⭕ 전체 대신 제한된 노출 배열(visiblePages)만 map 돌리기 */}
                        {visiblePages.map((page) => (
                            <button
                                key={page}
                                className={`page-btn ${currentPage === page ? "active" : ""}`}
                                onClick={() => handlePageChange(page)}
                            >
                                {page}
                            </button>
                        ))}

                        {/* > 다음 버튼 (다음 그룹의 첫 페이지로 이동) */}
                        <button 
                            className="page-btn direction"
                            disabled={currentPage === totalPages}
                            onClick={() => handlePageChange(Math.min(totalPages, endPage + 1))}
                        >
                            다음
                        </button>
                    
                        {/* 맨 끝으로 가는 버튼 (>>) - 2000페이지 이동용 */}
                        <button 
                            className="page-btn direction"
                            disabled={currentPage === totalPages}
                            onClick={() => handlePageChange(totalPages)}
                        >
                            마지막
                        </button>
                    </div>
                );
            })()}

            {/* [추가] 모달 컴포넌트 - 사용자 추가 폼 (간단한 예시) */}
            {isModalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <h3>사용자 추가</h3>
                        <form autoComplete="off"
                              onSubmit={(e) => {
                            e.preventDefault(); 
                            
                            const currentId = (newUser?.login_id || "").trim();
                            const currentName = (newUser?.name || "").trim();
                            const currentPass = newUser?.password || "";
                            const currentuserId = sessionStorage.getItem("userId")   || "";

                            
                            if (!currentId || !currentName || !currentPass) {
                                alert("모든 필드를 입력해주세요.");
                                return;
                            }
                            if (currentPass.length < 4) {
                                alert("비밀번호는 4글자 이상이어야 합니다.");
                                return;
                            }
                            if (idError !== "사용 가능한 ID입니다.") {
                                alert("아이디 중복 체크를 완료해주세요.");
                                return;
                            }
                        
                            // 서버 전송용 데이터 구성
                            const payload = {
                                login_id: currentId,
                                name: currentName,
                                password: currentPass, 
                                userId: currentuserId
                            };
                        
                            fetch(`${API_BASE_URL}/users/insert`, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `Bearer ${token}`
                                },
                                body: JSON.stringify(payload)
                            })
                            .then(res => {
                                if (!res.ok) throw new Error("사용자 등록 실패");
                                return res.json();
                            })
                            .then(() => {
                                alert("사용자가 등록되었습니다.");
                                setUsers(prev => [payload, ...(Array.isArray(prev) ? prev : [])]); 
                                setIsModalOpen(false); 
                                setNewUser({ login_id: "", password: "", name: "" }); // 초기화
                                setIdError(""); // 에러 메시지 초기화
                                // 컴포넌트 상단에 정의된 데이터 로드 함수명을 확인 후 입력하세요.
                                fetchUsers(); 
    
                            })
                            .catch(err => {
                                console.error("등록 에러:", err);
                                alert("등록 중 에러가 발생했습니다.");
                            });
                        }}>
                            {/* 1. 로그인 ID 입력 및 중복 체크 버튼 */}
                            <div style={{ marginBottom: "12px" }}>
                                <label style={{ display: "block", marginBottom: "4px", fontWeight: "bold", fontSize: "12px" }}>아이디(ID)</label>
                                <div style={{ display: "flex", gap: "8px", alignItems: "center", width: "100%" }}>
                                    <input
                                        type="text"
                                        placeholder="로그인 ID"
                                        autoComplete="one-time-code" 
                                        value={newUser?.login_id || ""}
                                        onChange={e => {
                                            setNewUser(prev => ({ ...prev, login_id: e.target.value }));
                                            setIdError(""); // 아이디를 다시 타이핑하면 중복 체크 상태 리셋
                                        }}
                                        style={{ 
                                                  width: "70%",
                                                  padding: "10px 12px",     // 💡 여백을 줘서 입력창을 시원하게 만듭니다
                                                  boxSizing: "border-box",
                                                  border: "1px solid #ccc",  // 💡 연하고 깔끔한 회색 테두리
                                                  borderRadius: "4px",       // 💡 부드러운 둥근 모서리
                                                  fontSize: "14px",          // 💡 글자 크기를 14픽셀로 통일
                                                  height: "40px"             // 💡 전체 세로 높이를 40픽셀로 딱 고정
                                              }}
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={() => {
                                            const currentId = (newUser?.login_id || "").trim();
                                            if (!currentId) {
                                                alert("ID를 입력한 후 중복 체크를 해주세요.");
                                                return;
                                            }
                                        
                                            // 백엔드로 ID 중복 체크 요청전송 (POST 방식 가정)
                                            fetch(`${API_BASE_URL}/managers/idcheck`, {
                                                method: "POST",
                                                headers: {
                                                    "Content-Type": "application/json",
                                                    Authorization: `Bearer ${token}`
                                                },
                                                body: JSON.stringify({ login_id: currentId })
                                            })
                                            .then(res => {
                                                if (!res.ok) {
                                                    throw new Error("서버 응답 실패");
                                                }
                                                return res.json(); // 단 한 번만 리턴
                                            })
                                            .then(data => {
                                                if (data.isDuplicate) {
                                                    setIdError("이미 존재하는 ID입니다.");
                                                } else {
                                                    setIdError("사용 가능한 ID입니다.");
                                                }
                                            })
                                            .catch(err => {
                                                console.error("ID 체크 에러:", err);
                                                alert("중복 체크 중 오류가 발생했습니다.");
                                            });
                                        }}
                                        style={{ 
                                            padding: "10px 16px",     // 개발자 도구에 있던 패딩 유지
                                            height: "38px",          // 인풋창과 동일한 높이 지정으로 상하 대칭 정렬
                                            backgroundColor: "#495057", 
                                            color: "#fff", 
                                            border: "none", 
                                            borderRadius: "4px", 
                                            cursor: "pointer"
                                            // ❌ 기존 스타일에 있던 margin-left: "auto" 속성은 삭제해 주세요!
                                        }}
                                    >
                                        중복 체크
                                    </button>
                                </div>
                                {idError && (
                                    <span style={{ fontSize: "11px", display: "block", marginTop: "4px", color: idError === "사용 가능한 ID입니다." ? "green" : "red" }}>
                                        {idError}
                                    </span>
                                )}
                            </div>
                            
                            {/* 2. 이름 입력 */}
                            <div style={{ marginBottom: "12px" }}>
                                <label style={{ display: "block", marginBottom: "4px", fontWeight: "bold", fontSize: "12px" }}>이름</label>
                                <input
                                    type="text"
                                    placeholder="이름"
                                    value={newUser?.name || ""}
                                    onChange={e => setNewUser(prev => ({ ...prev, name: e.target.value }))}
                                        style={{ 
                                                  width: "100%", 
                                                  padding: "10px 12px",     // 💡 여백을 줘서 입력창을 시원하게 만듭니다
                                                  boxSizing: "border-box",
                                                  border: "1px solid #ccc",  // 💡 연하고 깔끔한 회색 테두리
                                                  borderRadius: "4px",       // 💡 부드러운 둥근 모서리
                                                  fontSize: "14px",          // 💡 글자 크기를 14픽셀로 통일
                                                  height: "40px"             // 💡 전체 세로 높이를 40픽셀로 딱 고정
                                              }}
                                    required
                                />
                            </div>
                                          
                            {/* 3. 비밀번호 입력 */}
                            <div style={{ marginBottom: "20px" }}>
                                <label style={{ display: "block", marginBottom: "4px", fontWeight: "bold", fontSize: "12px" }}>비밀번호</label>
                                <input
                                    type="password"
                                    placeholder="비밀번호 (4자 이상)"
                                    autoComplete="new-password"
                                    value={newUser?.password || ""}
                                    onChange={e => setNewUser(prev => ({ ...prev, password: e.target.value }))}
                                        style={{ 
                                                  width: "100%", 
                                                  padding: "10px 12px",     // 💡 여백을 줘서 입력창을 시원하게 만듭니다
                                                  boxSizing: "border-box",
                                                  border: "1px solid #ccc",  // 💡 연하고 깔끔한 회색 테두리
                                                  borderRadius: "4px",       // 💡 부드러운 둥근 모서리
                                                  fontSize: "14px",          // 💡 글자 크기를 14픽셀로 통일
                                                  height: "40px"             // 💡 전체 세로 높이를 40픽셀로 딱 고정
                                              }}
                                    required
                                />
                            </div>
                                          
                            {/* 버튼 제어 */}
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                                <button type="submit" disabled={idError !== "사용 가능한 ID입니다."}
                                style={{ 
                                            backgroundColor: idError === "사용 가능한 ID입니다." ? "#007bff" : "#6c757d",
                                            color: "#fff", 
                                            border: "none", 
                                            borderRadius: "4px", 
                                            cursor: "pointer"
                                        }}
                                >저장</button>
                                <button type="button" onClick={() => {
                                    setIsModalOpen(false);
                                    setNewUser({ login_id: "", password: "", name: "" }); 
                                    setIdError("");
                                }}
                                style={{ 
                                            backgroundColor: "#e44d4d", 
                                            color: "#fff", 
                                            border: "none", 
                                            borderRadius: "4px", 
                                            cursor: "pointer"
                                        }}>
                                    취소
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* 💡 엑셀 업로드 모달창 팝업 정의 */}
            {modalType === 'excelUpload' && (
                <div className="modal">
                    <div className="modal-content" style={{ maxWidth: "450px" }}> {/* 사용자 추가 모달 크기와 비슷하게 맞춤 */}
                        <h3>엑셀 데이터 DB 업로드</h3>
                        <p style={{ fontSize: '13px', color: '#666', marginBottom: '20px' }}>
                            첫 번째 줄(제목)을 제외한 모든 행의 데이터를 한 줄씩 읽어 데이터베이스에 동기화합니다.
                        </p>
            
                        <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>

                            {/* 1. 파일 선택 및 업로드 대기 영역 */}
                            <div style={{ marginBottom: "12px" }}>
                                <label style={{ display: "block", marginBottom: "4px", fontWeight: "bold", fontSize: "12px" }}>파일 첨부</label>
                                <div style={{ display: "flex", gap: "8px", alignItems: "center", width: "100%" }}>
                                    {/* 숨김 처리된 실제 파일 인풋 */}
                                    <input 
                                        type="file" 
                                        accept=".xlsx, .xls" 
                                        ref={excelInputRef} 
                                        onChange={handleExcelFileChange} 
                                        style={{ display: 'none' }} 
                                    />
                                    {/* 시각용 가짜 파일 경로 안내창 */}
                                    <input
                                        type="text"
                                        placeholder="선택된 파일이 없습니다"
                                        value={excelRows.length > 1 ? `감지된 행: ${excelRows.length - 1}개 행` : ""}
                                        readOnly
                                        style={{ 
                                            width: "70%",
                                            padding: "10px 12px",
                                            boxSizing: "border-box",
                                            border: "1px solid #ccc",
                                            borderRadius: "4px",
                                            fontSize: "14px",
                                            height: "40px",
                                            background: "#f9f9f9"
                                        }}
                                    />
                                    {/* 사용자 추가 폼의 중복 체크 버튼과 동일한 규격의 파일선택 버튼 */}
                                    <button
                                        type="button"
                                        onClick={() => excelInputRef.current.click()} 
                                        disabled={isExcelUploading}
                                        style={{ 
                                            padding: "10px 16px",
                                            height: "40px",
                                            background: "#17a2b8",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "4px",
                                            fontSize: "14px",
                                            cursor: isExcelUploading ? "not-allowed" : "pointer"
                                        }}
                                    >
                                        파일 선택
                                    </button>
                                </div>
                            </div>
                                    
                            {/* 2. 상태 알림 및 성공 피드백 배지 구역 */}
                            {excelRows.length > 1 && !isExcelUploading && (
                                <div style={{ fontSize: '13px', color: '#28a745', background: '#e8f5e9', padding: '10px', borderRadius: '4px', marginBottom: '15px', border: '1px solid #c8e6c9', textAlign: 'left' }}>
                                    ✅ 정상 확인: 데이터 업로드를 시작할 준비가 완료되었습니다.
                                </div>
                            )}

                            {/* 3. 실시간 진행률 프로그레스 바 UI */}
                            {isExcelUploading && (
                                <div style={{ width: '100%', margin: '20px 0 10px 0', textAlign: 'left' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#007bff', fontWeight: 'bold' }}>
                                        <span>서버 동기화 진행 상황</span>
                                        <span>{uploadProgress.current} / {uploadProgress.total}</span>
                                    </div>
                                    <div style={{ width: '100%', background: '#e9ecef', height: '10px', borderRadius: '5px', marginTop: '6px', overflow: 'hidden' }}>
                                        <div 
                                            style={{ 
                                                width: `${(uploadProgress.current / uploadProgress.total) * 100}%`, 
                                                background: '#28a745', 
                                                height: '100%', 
                                                transition: 'width 0.1s ease' 
                                            }}
                                        ></div>
                                    </div>
                                </div>
                            )}

                            {/* 4. 하단 버튼 제어 구역 (닫기 및 DB저장) */}
                            <div style={{ marginTop: "24px", display: "flex", gap: "8px", justifyContent: "flex-end" }}>
                                <button
                                    type="button"
                                    onClick={() => {
                                        if (isExcelUploading) return;
                                        setModalType(null);
                                        setExcelRows([]);
                                    }}
                                    disabled={isExcelUploading}
                                    style={{ 
                                        padding: "10px 16px",
                                        height: "40px",
                                        background: "#aaa",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "4px",
                                        fontSize: "14px",
                                        cursor: isExcelUploading ? "not-allowed" : "pointer"
                                    }}
                                >
                                    취소
                                </button>
                                <button
                                    type="button"
                                    onClick={handleExcelSaveSubmit} 
                                    disabled={isExcelUploading || excelRows.length <= 1}
                                    style={{ 
                                        padding: "10px 16px",
                                        height: "40px",
                                        background: excelRows.length > 1 ? "#28a745" : "#ccc",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "4px",
                                        fontSize: "14px",
                                        cursor: (excelRows.length > 1 && !isExcelUploading) ? "pointer" : "not-allowed"
                                    }}
                                >
                                    {isExcelUploading ? "저장 중..." : "DB 저장 시작"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

        </div>

    );
}

export default UserList;